import { defineMessages } from 'react-intl';

export default defineMessages({
  AboutTeslaHeader: {
    id: 'Footer.AboutTesla.Header',
    defaultMessage: 'About Tesla',
  },
  AboutTeslaOne: {
    id: 'Footer.AboutTesla.One',
    defaultMessage:
      'Tesla is accelerating the world’s transition to sustainable energy. We design, manufacture, sell and service the world’s best solar technology, energy storage systems, and electric vehicles, providing customers the opportunity to generate, store and consume energy entirely sustainably.',
  },
  AboutTeslaTwo: {
    id: 'Footer.AboutTesla.Two',
    defaultMessage:
      'Tesla is committed to hiring and developing top talent from around the world for any given discipline. Based in California, Tesla’s workforce spans across four continents. We work to build an inclusive environment in which all people, regardless of gender, race, religion, or background, can come to do their best work.',
  },
  AboutTeslaThree: {
    id: 'Footer.AboutTesla.Three',
    defaultMessage:
      'Our world-class teams operate with a non-conventional philosophy of inter-disciplinary collaboration. Each member of the team is expected to challenge and to be challenged, to create, and to innovate. We’re tackling the world’s most difficult and important problems—and we wouldn’t succeed without our shared passion for making the world a better place.',
  },
  LearnMore: {
    id: 'Footer.LearnMore',
    defaultMessage: 'Learn more about Tesla',
  },
  EqualOpportunityOne: {
    id: 'Footer.EqualOpportunity.Global',
    defaultMessage:
      'Tesla is an Equal Opportunity / Affirmative Action employer committed to diversity in the workplace. All qualified applicants will receive consideration for employment without regard to race, color, religion, sex, sexual orientation, age, national origin, disability, protected veteran status, gender identity or any other factor protected by applicable federal, state or local laws.',
  },
  EqualOpportunityOneAlternative: {
    id: 'Footer.EqualOpportunity.GlobalAlternative',
    defaultMessage:
      'Tesla is an Equal Opportunity / Affirmative Action employer committed to diversity in the workplace.',
  },
  EqualOpportunityTwo: {
    id: 'Footer.EqualOpportunity.More.One',
    defaultMessage:
      'Tesla is also committed to working with and providing reasonable accommodations to individuals with disabilities. Please let your recruiter know if you need an accommodation at any point during the interview process.',
  },
  EqualOpportunityThree: {
    id: 'Footer.EqualOpportunity.More.Two',
    defaultMessage:
      'For quick access to screen reading technology compatible with this site <a href="https://chrome.google.com/webstore/detail/chromevox/kgejglhpjiefppelpmljglcjbhoiplfn" target="_blank">click here to download a free compatible screen reader</a> (free step by step <a href="http://www.chromevox.com/tutorial" target="_blank">tutorial can be found here</a>). Please contact <a href="mailto:accommodationrequest@tesla.com">accommodationrequest@tesla.com</a> for additional information or to request accommodations.',
  },
  PrivacyOne: {
    id: 'Footer.Privacy.One',
    defaultMessage:
      'Privacy is a top priority for Tesla. We build it into our products and view it as an essential part of our business. To understand more about the data we collect and process as part of your application, please view our <a href="https://www.tesla.com/sites/default/files/downloads/global-tesla-talent-privacy-notice.pdf" target="_blank">Tesla Talent Privacy Notice</a>.',
  },
  PrivacyLocal: {
    id: 'Footer.Privacy.Local',
    defaultMessage:
      'Privacy is a top priority for Tesla. We build it into our products and view it as an essential part of our business. To understand more about the data we collect and process as part of your application, please view our {link}.',
  },
  PrivacyLocalLinkText: {
    id: 'Footer.Privacy.LocalLinkText',
    defaultMessage: 'Tesla Talent Privacy Notice',
  },
});
